import React, { useState, useEffect } from 'react'
import axios from 'axios'
//* Components
import Chirp from '../components/chirp/Chirp'
import StaticProfile from '../components/profile/StaticProfile'
//* Material UI
import Grid from '@material-ui/core/Grid'
//* Skelton
import ChirpSkeleton from '../util/ChirpSkeleton'
import ProfileSkeleton from '../util/ProfileSkeleton'
//* Redux
import { useDispatch, useSelector } from 'react-redux'
import { getUserData } from '../redux/actions/dataActions'

const User = ({ match }) => {
  //* Redux
  const dispatch = useDispatch()
  const { chirps, loading } = useSelector((state) => state.data)

  //* State
  const [profile, setProfile] = useState(null)
  const [chirpIdParam, setChirpIdParam] = useState(null)

  useEffect(() => {
    const handle = match.params.handle
    const chirpId = match.params.chirpId

    if (chirpId) setChirpIdParam(chirpId)

    dispatch(getUserData(handle))

    const fetchUserData = () => {
      axios
        .get(`/user/${handle}`)
        .then((res) => {
          setProfile(res.data.user)
        })
        .catch((err) => console.log(err))
    }
    fetchUserData()
  }, [dispatch, match])

  const chirpsMarkup = loading ? (
    <ChirpSkeleton />
  ) : chirps === null ? (
    <p>No chirps from this user</p>
  ) : !chirpIdParam ? (
    chirps.map((chirp) => <Chirp key={chirp.chirpId} chirp={chirp} />)
  ) : (
    chirps.map((chirp) => {
      if (chirp.chirpId !== chirpIdParam)
        return <Chirp key={chirp.chirpId} chirp={chirp} />
      else return <Chirp key={chirp.chirpId} chirp={chirp} openDialog />
    })
  )

  return (
    <Grid container spacing={8}>
      <Grid item sm={8} xs={12}>
        {chirpsMarkup}
      </Grid>
      <Grid item sm={4} xs={12}>
        {profile === null ? (
          <ProfileSkeleton />
        ) : (
          <StaticProfile profile={profile} />
        )}
      </Grid>
    </Grid>
  )
}

export default User
